/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_AddressInputs */

const vi_order_form_invoice_buyer_address = /** @type {(inputs: Order_Form_Invoice_Buyer_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ công ty trên hóa đơn`)
};

/**

* @param {Order_Form_Invoice_Buyer_AddressInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_address = /** @type {((inputs?: Order_Form_Invoice_Buyer_AddressInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_AddressInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_address(inputs)
});